import { useFirmId } from "@/firm/FirmProvider";
import { reexported__useFirmAssessments } from "./api/assessmentGetters";
import { usePrefetch } from "@/api/usePrefetch";

export const PreloadAssessments = () => {
    const { firmId } = useFirmId();
    usePrefetch(() => reexported__useFirmAssessments(firmId)); // start loading assessments as soon as possible
    return null;
};
